export async function appointmentIndexUseCase(status, origin, type, page, per_page, search, year, sort_by, appointmentRepostitory) {
    const result = await appointmentRepostitory.index(status, origin, type, page, per_page, search, year, sort_by);

    result.data.data.forEach(x => {
      const entity = new appointmentRepostitory.model_index(x);
    
      if (!entity.isValid()) {
        console.log(entity)
        throw new Error("Appointment Index inválido");
      }
    });

    return result.data;
}